import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetHistory, isMobile } from '@pascal/pascal-core';
import { SelectedRowWeb } from './selectedRow/web';
import { SelectedRowMobile } from './selectedRow/mobile';
import './GameHistory.scss';
import './SelectedHistory.scss';

export const BetHistoryWrp = observer(() => {
  const innerComponent = isMobile() ? SelectedRowMobile : SelectedRowWeb
  return <BetHistory selectedRow={innerComponent}/>
  })